// src/components/AdminProtectedRoute.js
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const AdminProtectedRoute = () => {
  const location = useLocation();

  // ✅ 1. Read the admin session exactly as it's saved in AdminLogin.jsx
  const adminSessionString = localStorage.getItem('fsl_admin_session');
  
  let isAuthenticated = false;

  if (adminSessionString) {
    try {
      const adminSession = JSON.parse(adminSessionString);
      
      // ✅ 2. Check ONLY if adminId exists (Role check removed)
      const hasAdminId = !!adminSession.adminId;
      
      isAuthenticated = hasAdminId;
    } catch (error) {
      console.error('💥 Failed to parse fsl_admin_session:', error);
      isAuthenticated = false;
    }
  }

  // ✅ 3. Redirect to /admin-login if not authenticated
  if (!isAuthenticated) {
    // Clear corrupted session data just in case
    localStorage.removeItem('fsl_admin_session');
    localStorage.removeItem('user'); 
    
    // Redirect to admin login, preserving the page they tried to visit
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  // ✅ 4. If authenticated, render the child admin routes
  return <Outlet />;
};

export default AdminProtectedRoute;